import React from "react"
import Img from "gatsby-image"

const Visual = props => {
  return (
    <React.Fragment>
      {props.visualType === "Video" ? (
        <video autoPlay muted playsInline loop>
          <source src={props.videoUrl} type="video/mp4"></source>
        </video>
      ) : props.image.localFile.childImageSharp ? (
        <Img fluid={props.image.localFile.childImageSharp.fluid} />
      ) : (
        <img
          alt=""
          style={{ width: "100%" }}
          src={props.image.localFile.publicURL}
        />
      )}
    </React.Fragment>
  )
}

export default Visual
